import { useEffect } from "react";
export var useBeforeUnload = function (props) {
    var shouldAddEventListener = props.shouldAddEventListener, onUnloadCallBack = props.onUnloadCallBack;
    var handleBeforeUnload = function (event) {
        event.preventDefault();
        var message = "";
        event.returnValue = message;
        onUnloadCallBack && onUnloadCallBack();
        return message;
    };
    useEffect(function () {
        var ignore = false;
        if (!ignore) {
            shouldAddEventListener &&
                window.addEventListener("beforeunload", handleBeforeUnload);
        }
        return function () {
            ignore = true;
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [shouldAddEventListener]);
};
